import { Component } from '@angular/core';

@Component({
  selector: 'app-dots-loader',
  imports: [],
  templateUrl: './dots-loader.component.html',
  styleUrl: './dots-loader.component.css',
})
export class DotsLoaderComponent {

}
